import { PortResolver } from "@nx/typescript-domain";
import { ExportArtifactRepository } from "../adapters/localdb/ExportArtifactRepository";
import { ModelInfoRepository } from "../adapters/localdb/ModelInfoRepository";
import { CaseConversionService } from "../domain/CaseConversion/CaseConversionService";
import { ICaseConversionService } from "../domain/CaseConversion/ICaseConversionService";
import { dependencies } from "../domain/dependencies";
import { domain } from "../domain/domain";
import { IExportArtifactRepository } from "../domain/ExportArtifacts/IExportArtifactRepository";
import { ExportGeneratorService } from "../domain/ExportGenerators/ExportGeneratorService";
import { IExportGeneratorService } from "../domain/ExportGenerators/IExportGeneratorService";
import { ExportProfileService } from "../domain/ExportProfiles/ExportProfileService";
import { IExportProfileService } from "../domain/ExportProfiles/IExportProfileService";
import {
    IImportExampleService,
    ImportExampleService,
} from "../domain/ImportExamples/ImportExampleService";
import { IModelInfoRepository } from "../domain/ModelInfos/IModelInfoRepository";
import { IModelInfoService } from "../domain/ModelInfos/IModelInfoService";
import { ModelInfoService } from "../domain/ModelInfos/ModelInfoService";
import { IParserService, ParserService } from "../domain/Parsers/ParserService";

export class Wiring {
    constructor() {
        const portResolver = new PortResolver();
        domain.setResolver(portResolver);
        dependencies.setResolver(portResolver);

        // register imports
        portResolver.registerInstance<IParserService>("IParserService", () => new ParserService());
        portResolver.registerInstance<IImportExampleService>("IImportExampleService", () => new ImportExampleService());
        portResolver.registerInstance<IModelInfoRepository>("IModelInfoRepository", () => new ModelInfoRepository());
        portResolver.registerInstance<IExportArtifactRepository>("IExportArtifactRepository", () => new ExportArtifactRepository());
        portResolver.registerInstance<IModelInfoService>("IModelInfoService", () => new ModelInfoService());
        portResolver.registerInstance<IExportGeneratorService>("IExportGeneratorService", () => new ExportGeneratorService());
        portResolver.registerInstance<ICaseConversionService>("ICaseConversionService", () => new CaseConversionService());

        portResolver.registerInstance<IExportProfileService>("IExportProfileService", () => new ExportProfileService());

        
    }
}

const wiring = new Wiring();
export default wiring;
